/**
 * Frontend MQTT service — thin fetchers for server-cached MQTT values.
 * The Express server maintains a live MQTT subscription; these functions
 * just do a single authenticated GET to read the latest cached values.
 */
import { apiFetch } from './api.js'

const BASE = (import.meta.env.VITE_API_BASE ?? '') + '/mqtt'

async function get(path) {
  const r = await apiFetch(`${BASE}${path}`)
  if (!r.ok) throw new Error(`MQTT data error: ${r.status}`)
  return r.json()
}

export const fetchBatteryDataMqtt  = () => get('/battery')
export const fetchBatteryCells     = () => get('/battery-cells')
export const fetchMqttOverview     = () => get('/overview')

export async function publishMqttTopic(topic, value) {
  const r = await apiFetch(`${BASE}/publish`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ topic, value }),
  })
  if (!r.ok) throw Object.assign(new Error('mqtt-publish-failed'), { status: r.status })
}
